import React from 'react';
import { Link } from 'react-router-dom';

function ReviewsReceivedPanel({ reviews, loading, emptyMessage }) {
  if (loading) return <div className="loading">Loading received reviews...</div>;

  if (!reviews || reviews.length === 0) {
    return (
      <div className="dashboard-panel">
        <h3>Reviews Received</h3>
        <div className="empty-state">{emptyMessage || 'No reviews received yet.'}</div>
      </div>
    );
  }

  return (
    <div className="dashboard-panel">
      <h3>Reviews Received</h3>
      <div className="dashboard-table-wrapper">
        <table className="file-table">
          <thead>
            <tr>
              <th>File Name</th>
              <th>Uploader</th>
              <th>Status</th>
              <th>Approved</th>
            </tr>
          </thead>
          <tbody>
            {reviews.map((review) => (
              <tr key={review.fileId} className={review.userApproved ? 'review-row-approved' : 'review-row-pending'}>
                <td className="file-name-cell">
                  <Link to={`/review/${review.fileId}`}>{review.fileName}</Link>
                </td>
                <td>{review.uploadedBy}</td>
                <td>
                  <span className={`badge badge-${review.status === 'Approved' ? 'success' : review.status === 'Rejected' ? 'danger' : 'warning'}`}>
                    {review.status}
                  </span>
                </td>
                <td>
                  <span className={`approval-indicator ${review.userApproved ? 'approved' : 'pending'}`}>
                    {review.userApproved ? '✅ Approved' : '⏳ Pending'}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default ReviewsReceivedPanel;
